import McNormalToggleChart from './McNormalToggleChart';

export default McNormalToggleChart;
